module.exports = __webpack_public_path__ + "images/init-new-projects@2x-17497c49915288595edaa4de6f1db3f0.png";